import { render, staticRenderFns } from "./SupplierUsersPage.vue?vue&type=template&id=41f5f5c8&"
import script from "./SupplierUsersPage.vue?vue&type=script&lang=js&"
export * from "./SupplierUsersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports